'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _memoize = require('transmute/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _isFromVisitor = require('conversations-schema/pubnub-message/operators/isFromVisitor');

var _isFromAgent = require('conversations-schema/pubnub-message/operators/isFromAgent');

var _getCustomEmailCaptureDelay = require('../../selectors/widgetDataSelectors/getCustomEmailCaptureDelay');

var _shouldCaptureVisitorEmailAddress = require('../../selectors/widgetDataSelectors/shouldCaptureVisitorEmailAddress');

var _widgetIsInAwayMode = require('../../availability/selectors/widgetIsInAwayMode');

var _publishEmailCapturePromptMessage = require('../actions/publishEmailCapturePromptMessage');

var _publishEmailCapturePromptMessage2 = _interopRequireDefault(_publishEmailCapturePromptMessage);

var _asyncActionTypes = require('../../pubsub/constants/asyncActionTypes');

var _makeRequestActionTypes = require('conversations-internal-clients/action-creators/operators/makeRequestActionTypes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_AGENT_JOIN_TIMEOUT_IN_MS = 6000;
var ONE_SECOND_IN_MS = 1000;

var PUBLISH_MESSAGE = (0, _makeRequestActionTypes.makeRequestActionTypes)(_asyncActionTypes.PUBLISH_MESSAGE);

var AgentResponseTimeoutMiddleware = function AgentResponseTimeoutMiddleware(store) {
  return function (next) {
    var timeouts = {};

    var clearResponseTimeout = function clearResponseTimeout(channel) {
      return clearTimeout(timeouts[channel]);
    };

    var setResponseTimeout = (0, _memoize2.default)(function (channel, delay) {
      timeouts[channel] = setTimeout(function () {
        store.dispatch((0, _publishEmailCapturePromptMessage2.default)({ channel: channel }));
      }, delay);
    });

    var clearResponseTimeoutCache = function clearResponseTimeoutCache() {
      setResponseTimeout.cache.clear();
    };

    return function (action) {
      switch (action.type) {
        case PUBLISH_MESSAGE.SUCCEEDED:
          {
            var _action$payload = action.payload,
                channel = _action$payload.channel,
                publishedMessage = _action$payload.publishedMessage;


            var isInAwayMode = (0, _widgetIsInAwayMode.widgetIsInAwayMode)(store.getState());

            /**
             * Once the visitor publishes his/her first message,
             * start a timer for a custom delay, if specified, or a standard delay
             */
            if ((isInAwayMode || (0, _shouldCaptureVisitorEmailAddress.shouldCaptureVisitorEmailAddress)(store.getState())) && (0, _messageTypeComparators.isConversationalMessage)(publishedMessage) && (0, _isFromVisitor.isFromVisitor)(publishedMessage)) {
              var customDelay = (0, _getCustomEmailCaptureDelay.getCustomEmailCaptureDelay)(store.getState());
              var timeout = isInAwayMode ? ONE_SECOND_IN_MS : customDelay || DEFAULT_AGENT_JOIN_TIMEOUT_IN_MS;

              setResponseTimeout(channel, timeout);
            }
            break;
          }

        case ActionTypes.RECEIVED_INCOMING_MESSAGE:
          {
            var _action$payload2 = action.payload,
                _channel = _action$payload2.channel,
                message = _action$payload2.message;

            /**
             * When a non-automated, conversational message is received from an agent,
             * cancel the timer
             */

            if ((0, _messageTypeComparators.isConversationalMessage)(message) && !(0, _messageTypeComparators.isAutomatedChatMessage)(message) && (0, _isFromAgent.isFromAgent)(message)) {
              clearResponseTimeout(_channel);
            }
            break;
          }

        case ActionTypes.END_CONVERSATION:
          {
            clearResponseTimeoutCache();
            break;
          }

        default:
          break;
      }

      return next(action);
    };
  };
};
exports.default = AgentResponseTimeoutMiddleware;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/email-capture/middleware/AgentResponseTimeoutMiddleware.js
// module id = 682
// module chunks = 2 3